// @ts-check
var ShopTheme = ShopTheme || {};

ShopTheme.Global = {
	DEBUG: false,
	pageUnderlay: document.querySelector("[data-underlay]"),
	pageModal: document.querySelector("[data-modal-container]"),
	toggleVisibility: function (element, isVisible) {
		if (isVisible) {
			element.classList.remove("hidden");
		} else {
			element.classList.add("hidden");
		}
	},
	fixBodyScroll: function (isFixed) {
		if (isFixed) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	},
	toggleModal: function (isVisible) {
		var element = ShopTheme.Global.pageModal;
		var body = document.body;
		if (!element || !body) {
			return;
		} else {
			if (isVisible) {
				element.addEventListener("click", function (event) {
					if (event.target === element) {
						ShopTheme.Global.toggleModal(false);
					}
				}),
					ShopTheme.Global.fixBodyScroll(true);
				// ShopTheme.Global.toggleOverlay(true);
				element.classList.remove("hidden");
			} else {
				ShopTheme.Global.fixBodyScroll(false);
				// ShopTheme.Global.toggleOverlay(false);
				element.classList.add("hidden");
			}
		}
	},
	toggleOverlay: function (isVisible) {
		var element = ShopTheme.Global.pageUnderlay;
		var body = document.body;
		if (!element || !body) {
			return;
		} else {
			if (ShopTheme.Global.DEBUG) console.log("Toggling overlay");
			if (isVisible) {
        if (ShopTheme.Global.DEBUG) console.log("Showing overlay");
				ShopTheme.Global.fixBodyScroll(true);
				element.classList.remove("hidden");
			} else {
        if (ShopTheme.Global.DEBUG) console.log("Hiding overlay");
				ShopTheme.Global.fixBodyScroll(false);
				element.classList.add("hidden");
			}
		}
	},
	toggleCartDrawer: function (isVisible) {
    if (this.DEBUG) console.log("toggleCartDrawer called");
		var cartDrawer = document.getElementById("cartDrawer");
		if (!cartDrawer) {
			return;
		}

		if (isVisible) {
			if (this.DEBUG) console.log("Opening cart drawer");
			cartDrawer.classList.remove("translate-x-full", "invisible");
			this.toggleOverlay(true);

		} else {
			if (this.DEBUG) console.log("Closing cart drawer");
			cartDrawer.classList.add("translate-x-full", "invisible");
			this.toggleOverlay(false);
		}
	},
  closeAllOverlayComponents: function() {
    if (this.DEBUG) console.log("Closing all overlay components");
		// Check if Quick Buy modal is open and close it
		if (!ShopTheme.Global.pageModal.classList.contains("open")) {
			// Assuming 'open' is a class indicating visibility
			ShopTheme.Global.toggleModal(false);
		}

		// Check if cart drawer is open and close it
		var cartDrawer = document.getElementById("cartDrawer");
		if (cartDrawer && !cartDrawer.classList.contains("hidden")) {
			// Assuming 'hidden' class indicates it is not visible
			ShopTheme.Global.toggleCartDrawer(false);
		}

		// Similarly for mobile menu, if it's open, close it
		var mobileMenu = document.querySelector(".mobile-menu"); // Assuming selector for mobile menu
		if (mobileMenu && mobileMenu.classList.contains("open")) {
			// Assuming 'open' class indicates visibility
			ShopTheme.MobileMenu.toggleMenu(false); // Adjust according to how you implemented toggle for mobile menu
		}
	},
};

ShopTheme.Menu = (function () {
	function hideAllMenus() {
		document.querySelectorAll("ul[data-child-menu]").forEach(function (menu) {
			menu.classList.add("hidden");
		});
	}

	function setupMenuToggle() {
		document
			.querySelectorAll('li[data-has-child-menu="true"] > a')
			.forEach(function (link) {
				link.addEventListener("click", function (event) {
					var parentLi = this.parentNode;
					var childMenu = parentLi.querySelector("ul[data-child-menu]");

					// Add a check here to ensure childMenu is not null
					if (!childMenu) {
						return; // Skip this iteration if childMenu is null
					}
					var isMenuHidden = childMenu.classList.contains("hidden");

					// Hide all menus before toggling the current one
					hideAllMenus();

					// Toggle current menu
					if (isMenuHidden) {
						event.preventDefault(); // Prevent default to show the hidden menu
						childMenu.classList.remove("hidden");
					} else {
						// Allow the default link behavior if the menu is already visible
					}
				});
			});
	}

	function setupDocumentClickListener() {
		document.addEventListener("click", function (event) {
			var isClickInsideMenu =
				event.target.closest("ul[data-child-menu]") ||
				event.target.closest('li[data-has-child-menu="true"]');
			if (!isClickInsideMenu) {
				hideAllMenus();
			}
		});
	}

	function init() {
		setupMenuToggle();
		setupDocumentClickListener();
	}

	// Public API
	return {
		init: init,
	};
})();

ShopTheme.MobileMenu = (function () {
	var underlay,
		menu,
		backButton,
		openMenuButton,
		breadcrumbsContainer,
		menuItems;

	function toggleMenu(open) {
		menu.classList.toggle("open", open);
		ShopTheme.Global.toggleOverlay(open);
		document.body.classList.toggle("overflow-hidden", open);
    if (open) {
      updateBackButton();
    } else {
      closeAllChildMenus();
      updateBreadcrumbs();
    }
	}

  function closeAllChildMenus() {
		const openChildMenus = document.querySelectorAll(".mobile-sub-menu.open");
		openChildMenus.forEach(function (menu) {
			menu.classList.remove("open");
		});
	}

	function updateBackButton() {
		const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
		backButton.innerHTML = openSubMenus.length > 0 ? "&lt; Back" : "&#10005;";
	}

  function updateBreadcrumbs(selectedItem) {
    if (selectedItem) {
      const primaryTitle = selectedItem.textContent.trim().split("\n")[0];
      breadcrumbsContainer.innerHTML = `${primaryTitle}`;
    } else {
      const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
      const parentMenuItemTitle =
        openSubMenus.length > 0
          ? openSubMenus[openSubMenus.length - 1]
              .closest("li")
              .textContent.trim()
              .split("\n")[0]
          : "Home";
      breadcrumbsContainer.innerHTML = `${parentMenuItemTitle}`;
    }
  }

  function handleMenuItemClick(e) {
    e.stopPropagation();
    const menuItem = e.currentTarget;
    if (menuItem.dataset.hasChildMenu === "true") {
      e.preventDefault();
      menuItem.querySelector("[data-mobile-child-menu]").classList.add("open");
    } else {
      toggleMenu(false);
    }
    updateBreadcrumbs(menuItem);
    updateBackButton();
  }

  function handleBackButtonClick() {
    const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
    const shouldCloseMenu = openSubMenus.length === 0;
    if (shouldCloseMenu) {
      toggleMenu(false);
    } else {
      openSubMenus[openSubMenus.length - 1].classList.remove("open");
      updateBreadcrumbs();
    }
  }

	function setupEventListeners() {
		openMenuButton.addEventListener("click", () => toggleMenu(true));
		backButton.addEventListener("click", handleBackButtonClick);
		underlay.addEventListener("click", function () {
			if (menu.classList.contains("open")) {
				toggleMenu(false); // Only toggle the menu if it's currently open
			}
		});
		menuItems.forEach((menuItem) =>
			menuItem.addEventListener("click", handleMenuItemClick)
		);
	}

	function init() {
		underlay = document.querySelector("[data-underlay]");
		menu = document.querySelector(".mobile-menu");
		backButton = document.querySelector("[data-back-button]");
		openMenuButton = document.querySelector("[data-open-mobile-menu]");
		breadcrumbsContainer = document.querySelector(".breadcrumbs");
		menuItems = document.querySelectorAll(".mobile-menu-items li");

		if (
			underlay &&
			menu &&
			backButton &&
			openMenuButton &&
			breadcrumbsContainer
		) {
			setupEventListeners();
		}
	}

	// Public API
	return {
		init: init,
	};
})();

ShopTheme.Cart = (function () {
	function addItem(itemId, quantity) {
		var addUrl = (localRoutes.cartAddRoute || "/cart/add") + ".js";

		fetch(addUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				items: [
					{
						id: itemId,
						quantity: quantity,
					},
				],
        sections: "main-cart,header-cart-button,cart-drawer",
			}),
		})
			.then((response) => response.json())
			.then((data) => {
        var cartUpdatedEvent = new CustomEvent("cart:updated", {
          detail: data,
        });
        document.dispatchEvent(cartUpdatedEvent);
			})
			.catch((error) => {
				console.error("Error adding item:", error);
        var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
			});
	}

	function updateItem(itemId, quantity) {
		var updateUrl = (localRoutes.cartUpdateRoute || "/cart/update") + ".js";

		fetch(updateUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				updates: {
					[itemId]: quantity,
				},
				sections: "main-cart,header-cart-button,cart-drawer",
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				// Additional logic after updating item quantity
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: data,
				});
				document.dispatchEvent(cartUpdatedEvent);
			})
			.catch((error) => {
				console.error("Error updating item:", error);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
			});
	}

  function submitForm(formData) {
    var addUrl = (localRoutes.cartAddRoute || "/cart/add") + ".js";
    formData.append("sections", "header-cart-button,cart-drawer");
    fetch(addUrl, {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				if (ShopTheme.Global.DEBUG) console.log("Cart updated:", data);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: data,
				});
				document.dispatchEvent(cartUpdatedEvent);
			})
			.catch((error) => {
				console.error("Error updating cart:", error);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
			});
  }

	return {
		addItem: addItem,
		updateItem: updateItem,
		submitForm: submitForm,
	};
})();

ShopTheme.ProductForm = (function () {
	function init() {
		setupProductFormListener();
	}

	function setupProductFormListener() {
    if (ShopTheme.Global.DEBUG) console.log("Setting up product form listener");
		const productForm = document.querySelector('form[action="/cart/add"]');
		if (productForm) {
      if (ShopTheme.Global.DEBUG) console.log("Product form found");
      productForm.removeEventListener("submit", handleProductFormSubmit);
			productForm.addEventListener("submit", handleProductFormSubmit);
		}
	}

  function handleProductFormSubmit(event) {
    if (ShopTheme.Global.DEBUG) console.log("Product form submitted", event);
    event.preventDefault();
    const formData = new FormData(event.target);
    ShopTheme.Cart.submitForm(formData);
  }

	return {
		init: init,
		setupProductFormListener: setupProductFormListener
	};
})();

ShopTheme.Cart.updateSections = function (sections, callback) {
  if (!sections) {
    return;
  } else {
    Object.keys(sections).forEach(function (sectionKey) {
      var newSectionHtml = sections[sectionKey];
      var parser = new DOMParser();
      var newSectionDoc = parser.parseFromString(newSectionHtml, "text/html");

      newSectionDoc
        .querySelectorAll("[data-section-target]")
        .forEach(function (newSectionPart) {
          var targetAttr = newSectionPart.getAttribute("data-section-target");
          var currentSectionPart = document.querySelector(
            '[data-section-target="' + targetAttr + '"]'
          );

          if (currentSectionPart) {
            currentSectionPart.replaceWith(newSectionPart);
          }
        });
    });
  }
  ShopTheme.Cart.setupCartEventListeners();
  if (typeof callback === "function") {
		callback(); // Execute the callback
	}
};

ShopTheme.Product = (function () {
	function init() {
		setupRadioButtons();
    setupVariantChangeListener();
    updateSubmitButtonState();
	}

  function setupVariantChangeListener() {
		const variantSelect = document.getElementById("variant-select");
		if (variantSelect) {
			variantSelect.addEventListener("change", onVariantChange);
		}
	}

  function onVariantChange() {
    if (allFieldsetsHaveSelection()) {
      const variantSelect = document.getElementById('variant-select');
      const productPageSection = document.querySelector('[data-section-target="main-product"]');
      const quickBuySection = document.querySelector('[data-section-target="product-quick-buy"]');
      if (variantSelect) {
        const variantId = variantSelect.value;
        if (ShopTheme.Global.DEBUG) console.log("Variant changed to:", variantId);

        // Create and dispatch custom event with variant data
        const variantChangeEvent = new CustomEvent('variant:changed', {
          detail: {
            variantId: variantId
          },
          bubbles: true // This allows the event to bubble up through the DOM
        });
        variantSelect.dispatchEvent(variantChangeEvent);

        // Update the URL with the new variant ID
        if (window.location.pathname.includes('/products/')) {
          if (ShopTheme.Global.DEBUG) console.log("Updating URL with variant ID", variantId);
          const newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variantId;
          window.history.replaceState({ path: newUrl }, "", newUrl);
        }

        // Update the sections required when a variant changes
        if (productPageSection) {
          updateProductSection(variantId);
        } else if (quickBuySection) {
          updateQuickBuySection(variantId);
        }
      }
    }
}

  function updateProductSection(variantId) {
		if (ShopTheme.Global.DEBUG) console.log("Updating product section", variantId);
		// Update to use the active section rather than
		const sectionId = document
			.querySelector('[data-section-target="main-product"]')
			.getAttribute("data-sectionId");
		const url = window.location.href + "&section_id=" + sectionId;
		fetch(url)
			.then((response) => response.text())
			.then((html) => {
				const newSection = new DOMParser()
					.parseFromString(html, "text/html")
					.querySelector('[data-section-target="main-product"]');
				const currentSection = document.querySelector(
					'[data-section-target="main-product"]'
				);
				if (currentSection && newSection) {
					currentSection.replaceWith(newSection);
				}
				reattachEventListeners(); // Reattach event listeners to new DOM elements
				updateSubmitButtonState();

				// Reinitialize the bundle accordion logic
				ShopTheme.Global.initializeBundleAccordion();
			});
	}

  function updateQuickBuySection(variantId) {
		if (ShopTheme.Global.DEBUG) console.log("Updating quick buy section", variantId);
		const sectionId = document
			.querySelector('[data-section-target="product-quick-buy"]')
			.getAttribute("data-sectionId");
		const productHandle = document
			.querySelector('[data-section-target="product-quick-buy"]')
			.getAttribute("data-productHandle");
		const url = `${window.location.origin}/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;
    if (ShopTheme.Global.DEBUG) console.log("Fetching URL:", url);
		fetch(url)
			.then((response) => response.text())
			.then((html) => {
				const newSection = new DOMParser()
					.parseFromString(html, "text/html")
					.querySelector('[data-section-target="product-quick-buy"]');
				const currentSection = document.querySelector(
					'[data-section-target="product-quick-buy"]'
				);
				if (ShopTheme.Global.DEBUG) console.log("Current section:", currentSection);
				if (ShopTheme.Global.DEBUG) console.log("New section:", newSection);
				if (currentSection && newSection) {
					currentSection.replaceWith(newSection);
				}
				reattachEventListeners(); // Reattach event listeners to new DOM elements
				updateSubmitButtonState();
			});
	}

  function reattachEventListeners() {
		setupRadioButtons(); // Reattach event listeners for radio buttons
		setupVariantChangeListener(); // Reattach the variant change listener
    ShopTheme.Cart.setupCartEventListeners(); // Reattach cart event listeners
		ShopTheme.ProductForm.setupProductFormListener();
	}

	function setupRadioButtons() {
		const radioButtons = document.querySelectorAll('input[type="radio"]');
		radioButtons.forEach((radio) => {
			radio.addEventListener("change", onRadioButtonChange);
		});
	}

	function onRadioButtonChange() {
		const selectedOptions = getSelectedOptions();
		const variantSelect = document.getElementById("variant-select");
		const matchingVariant = findMatchingVariant(selectedOptions, variantSelect);
		if (matchingVariant) {
			variantSelect.value = matchingVariant.value;
			variantSelect.dispatchEvent(new Event("change")); // Trigger change event if needed
		}
		updateSubmitButtonState();
	}

	function getSelectedOptions() {
		const options = {};
		document.querySelectorAll("fieldset").forEach((fieldset) => {
			const checkedRadio = fieldset.querySelector(
				'input[type="radio"]:checked'
			);
			if (checkedRadio) {
				options[checkedRadio.name] = checkedRadio.value;
			}
		});
		return options;
	}

	function findMatchingVariant(selectedOptions, variantSelect) {
    if (variantSelect) {
      return Array.from(variantSelect.options).find((option) => {
        return Object.keys(selectedOptions).every((key) => {
          const optionKey = "data-variant-" + key;
          return (
            !option.hasAttribute(optionKey) ||
            option.getAttribute(optionKey) === selectedOptions[key]
          );
        });
      });
    } else {
      return null;
    }
	}

  function allFieldsetsHaveSelection() {
		const fieldsets = document.querySelectorAll("fieldset");
		return Array.from(fieldsets).every((fieldset) =>
			fieldset.querySelector('input[type="radio"]:checked')
		);
	}

  function updateSubmitButtonState() {
		const submitButton = document.querySelector('input[type="submit"]');
		if (!submitButton) {
			return;
		}
		const allSelected = allFieldsetsHaveSelection();

		// if (!allSelected) {
		//   if (ShopTheme.Global.DEBUG) console.log("Not all selected");
		// } else {
		//   if (ShopTheme.Global.DEBUG) console.log("All selected");
		// }

		submitButton.disabled = !allSelected;
	}

	return {
		init: init,
	};
})();

ShopTheme.QuickBuy = (function () {
	var modalContainer = null;

	function closeQuickBuyModal(closeModal, closeOverlay) {
    if (ShopTheme.Global.DEBUG) console.log("Closing quick buy modal");
		if (closeOverlay) ShopTheme.Global.toggleOverlay(false);
		if (closeModal) ShopTheme.Global.toggleModal(false);
	}

	function handleCloseModalClick() {
    if (ShopTheme.Global.DEBUG) console.log("Close modal button clicked");
		closeQuickBuyModal(true, true);
	}

	function handleQuickBuyButtonClick(e) {
    if (ShopTheme.Global.DEBUG) console.log("Quick buy button clicked");
    e.stopImmediatePropagation();
		const button = e.currentTarget;
		const onlyVariant = button.getAttribute("data-only-variant") === "true";
		const productHandle = button.getAttribute("data-product-handle");
		e.preventDefault();

		if (onlyVariant) {
			var variantId = button.getAttribute("data-variant-id");
			ShopTheme.Cart.addItem(variantId, 1);
		} else {
			const url = `${window.location.origin}/products/${productHandle}?section_id=product-quick-buy`;
			fetch(url)
				.then((response) => response.text())
				.then((html) => {
					modalContainer = document.querySelector("[data-modal-container]");
					if (modalContainer) {
						modalContainer.querySelector(
							"[data-modal-container-content]"
						).innerHTML = html;
            ShopTheme.Global.toggleOverlay(true);
						ShopTheme.Global.toggleModal(true);
						ShopTheme.Product.init();
            if (ShopTheme.Global.DEBUG) console.log("Reattaching event listeners");
            ShopTheme.Cart.setupCartEventListeners();
            // TODO: Add reattach event listeners for quantities

          modalContainer
            .querySelectorAll("[data-close-modal]")
            .forEach((closeModalButton) => {
              closeModalButton.addEventListener(
                "click",
                handleCloseModalClick
              );
            });
        } else {
          console.error("Modal container not found");
        }
      })
      .catch((error) => console.error("Error loading the section:", error));
		}
	}

	function setupQuickBuyButtonListeners() {
		const quickBuyButtons = document.querySelectorAll(
			"[data-quick-buy-button]"
		);
		quickBuyButtons.forEach((button) => {
			button.removeEventListener("click", handleQuickBuyButtonClick);
			button.addEventListener("click", handleQuickBuyButtonClick);
		});
	}

	function init() {
		setupQuickBuyButtonListeners();
		// Listen for cart:updated event to close the quick buy modal when an item is added
		document.addEventListener("cart:updated", () => closeQuickBuyModal(true, false));
	}

	return {
		init: init,
	};
})();

ShopTheme.Cart.setupCartEventListeners = function () {

  if (ShopTheme.Global.DEBUG) console.log("Setting up cart event listeners");

  // Event listener for adding items to the cart
  document.querySelectorAll("[data-remove-item]").forEach((button) => {
    button.addEventListener("click", function () {
      const itemId = this.getAttribute("data-remove-item");
      ShopTheme.Cart.updateItem(itemId, 0); // Remove item by setting quantity to 0
    });
  });

  // Event listener for updating item quantities
  document.querySelectorAll("[data-update-item]").forEach((input) => {
    input.addEventListener("change", function () {
      const itemId = this.getAttribute("data-update-item");
      const quantity = parseInt(this.value);
      ShopTheme.Cart.updateItem(itemId, quantity); // Update item quantity
    });
  });

  // Quantity handling has been moved to quantity-handler.js for better organization
  // and to use delegated events that work with dynamically loaded content

};

ShopTheme.Global.setupGlobalEventListeners = function () {
	// Event listener for closing the cart drawer
	var buttonSelectors = ["continueShopping", "closeCartDrawer"];
	buttonSelectors.forEach(function(selector) {
		var button = document.getElementById(selector);
		if (button) {
			button.addEventListener("click", function() {
				ShopTheme.Global.toggleCartDrawer(false);
			});
		}
	});

  ShopTheme.Global.pageUnderlay.addEventListener("click", function () {
		ShopTheme.Global.closeAllOverlayComponents();
	});

  var cartToggleButtons = document.querySelectorAll("[data-toggle-cart]");
  cartToggleButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      // This prevents the click from immediately closing the drawer because it's outside of the cart drawer
      e.stopPropagation();
      ShopTheme.Global.toggleCartDrawer(true);
    });
  });

  function isCartPage() {
		return window.location.pathname.includes("/cart");
	}

  document.addEventListener("cart:updated", function (event) {
    ShopTheme.Cart.updateSections(event.detail.sections, function () {
      if (!isCartPage()) {
        ShopTheme.Global.toggleCartDrawer(true);
      }
    });
  });

};

ShopTheme.Global.initializeBundleAccordion = function (rootElement = document) {
	const specialBundlingElement = rootElement.querySelector(
		"[data-special-bundling]"
	);
	if (!specialBundlingElement) return; // Exit if special bundling UI is not present

	// Immediately disable the Add to Cart button
	const addToCartButton = rootElement.querySelector("[data-add-to-cart]");
	if (addToCartButton) {
		addToCartButton.disabled = true; // Disable initially
	}

	const classForHiding = "max-h-0";

	// Function to initialize accordion functionality for Special Bundling
	const initAccordion = () => {
		rootElement.querySelectorAll(".accordion-button").forEach((button) => {
			button.addEventListener("click", () => {
				const targetId = button.getAttribute("data-accordion-target");
				const content = rootElement.getElementById(
					`accordion-content-${targetId}`
				);
				const parentSection = button.closest(".accordion-section");

				if (!parentSection || !content) return;

				// Close all other accordions
				rootElement
					.querySelectorAll(".accordion-content")
					.forEach((section) => {
						if (section !== content) {
							section.classList.add(classForHiding);
							const otherParentSection = section.closest(".accordion-section");
							if (otherParentSection) {
								otherParentSection.setAttribute(
									"data-accordion-expanded",
									"false"
								);
							}
							section.setAttribute("aria-expanded", "false");
						}
					});

				// Toggle visibility
				content.classList.toggle(classForHiding);

				// Update ARIA attributes on parent section
				const isExpanded = content.classList.contains(classForHiding)
					? "false"
					: "true";
				parentSection.setAttribute("data-accordion-expanded", isExpanded);
				content.setAttribute("aria-expanded", isExpanded);
			});
		});
	};

	// Function to handle radio group selection for Special Bundling
	const initRadioGroups = () => {
		rootElement.querySelectorAll(".special-bundling .radio-group").forEach((group) => {
			const select = rootElement.getElementById(group.dataset.selectId);

			group.querySelectorAll(".radio-label:not(.disabled)").forEach((label) => {
				label.addEventListener("click", () => {
					// Deselect all radio labels in the current group
					group
						.querySelectorAll(".radio-label")
						.forEach((l) => l.classList.remove("selected"));
					label.classList.add("selected");
					select.value = label.dataset.value;
					select.dispatchEvent(new Event("change"));

					const selectedSku = label.dataset.sku;

					// Update the Ingredients button with the selected SKU
					const accordionSection = group.closest(".accordion-section");
					const ingredientsButton = accordionSection.querySelector(
						"[data-ingredients-btn]"
					);
					if (ingredientsButton) {
						ingredientsButton.dataset.sku = selectedSku;
					}

					// Add class to the current accordion section when selection is made
					accordionSection.classList.add("option-selected");

					// Update the button text with the selected option name
					const accordionButton =
						accordionSection.querySelector(".accordion-button");
					const accordionButtonText =
						accordionButton.querySelector(".button-text");
					const selectedOptionName = label.textContent.trim();
					accordionButtonText.textContent = `${selectedOptionName}`;

					// Close all open accordion sections
					rootElement
						.querySelectorAll(".accordion-content")
						.forEach((section) => {
							if (section !== group.closest(".accordion-content")) {
								section.classList.add(classForHiding);
							}
						});

					// Show the next accordion section only if it doesn't have the 'option-selected' class
					const currentSection = group.closest(".accordion-content");
					const nextSection =
						currentSection.parentNode.nextElementSibling?.querySelector(
							".accordion-content"
						);
					currentSection.classList.add(classForHiding); // Hide the current section

					if (
						nextSection &&
						!nextSection
							.closest(".accordion-section")
							.classList.contains("option-selected")
					) {
						nextSection.classList.remove(classForHiding); // Show the next section
					}
          updateBundleContents(); // Update the bundle contents
					checkAllSelectionsMade(); // Check if all selections are made and enable the Add to Cart button
				});
			});
		});
	};

	// Function to update bundle contents
	const updateBundleContents = () => {
		const bundleContents = [];
		const bundleQuantity = rootElement.querySelectorAll(
			".radio-group[data-select-id]"
		).length;

		for (let i = 1; i <= bundleQuantity; i++) {
			const selectElement = rootElement.getElementById(`option-${i}`);
			if (selectElement) {
				// Add SKU to bundleContents
				bundleContents.push(selectElement.value);

				// Create or update hidden input for line item properties
				let hiddenInput = rootElement.getElementById(
					`bundle-option-${i}-title`
				);
				if (!hiddenInput) {
					hiddenInput = rootElement.createElement("input");
					hiddenInput.type = "hidden";
					hiddenInput.id = `bundle-option-${i}-title`;
					hiddenInput.name = `properties[bundle-option-${i}]`;
					selectElement.parentNode.appendChild(hiddenInput);
				}

				// Set the hidden input's value to the variant title
				const selectedOption =
					selectElement.options[selectElement.selectedIndex];
				hiddenInput.value = selectedOption.getAttribute("data-variant-title");
			}
		}

		// Update the bundle contents input with a comma-separated list of SKUs
		const bundleContentsInput = rootElement.getElementById("bundle-contents");
		if (bundleContentsInput) {
			bundleContentsInput.value = bundleContents.join(",");
		}
	};


	// Check if all selections are made
	const checkAllSelectionsMade = () => {
		// Dynamically calculate the number of bundle options
		const bundleQuantity = rootElement.querySelectorAll(
			".radio-group[data-select-id]"
		).length;

		// If there are no bundle options (just default variant), enable the button
		if (bundleQuantity === 0) {
			const addToCartButton = rootElement.querySelector("[data-add-to-cart]");
			if (addToCartButton) {
				addToCartButton.disabled = false;
			}
			return;
		}

		let allSelected = true;

		for (let i = 1; i <= bundleQuantity; i++) {
			const radioGroup = rootElement.querySelector(
				`[data-select-id="option-${i}"]`
			);
			const hasSelectedLabel = radioGroup.querySelector(
				".radio-label.selected"
			);

			if (!hasSelectedLabel) {
				allSelected = false;
				break;
			}
		}

		const addToCartButton = rootElement.querySelector("[data-add-to-cart]");
		if (addToCartButton) {
			addToCartButton.disabled = !allSelected;
		}
	};

	// Add event listeners
	initAccordion();
	initRadioGroups();

	rootElement.addEventListener("change", (event) => {
		if (
			event.target.tagName.toLowerCase() === "select" &&
			event.target.id.startsWith("option-")
		) {
			updateBundleContents();
			checkAllSelectionsMade();
		}
	});

	// Check initial state - enable button if no bundles or check bundle selections
	checkAllSelectionsMade();
};

// Initialize the QuickBuy module along with other modules
document.addEventListener("DOMContentLoaded", function () {
	ShopTheme.Global.setupGlobalEventListeners();
	ShopTheme.Cart.setupCartEventListeners();
	ShopTheme.Product.init();
	ShopTheme.ProductForm.init();
	ShopTheme.Menu.init();
	ShopTheme.MobileMenu.init();
	ShopTheme.QuickBuy.init(); // Initialize the QuickBuy module
	ShopTheme.Global.initializeBundleAccordion(); // Init the bundle accordion on the product page

	// New underlay click handler for closing modals
	const overlay = document.querySelector("[data-underlay]");
	if (overlay) {
		overlay.addEventListener("click", function () {
			const modals = document.querySelectorAll(
				"[data-modal-container], [data-modal]"
			);
			modals.forEach((modal) => modal.classList.add("hidden"));
			document.body.classList.remove("overflow-hidden");
			ShopTheme.Global.toggleOverlay(false);
		});
	}
});

